import React from 'react';
import './App.css';
import View from './view/View';

const App: React.FC = () => {
  return (
    <div className="App">
      <div id="content">
            <div id="logo"><img src="./logo.png" /></div>
            <div id="title">
                <span className="grey">It's</span>
                &nbsp;
                <span>Anno</span>                
            </div>
            <div id="mid">Real-time knowledge discovery</div>
            <div id="tagline" className="grey">
                Have you ever stared at&nbsp;
                <span className="thing-container">
                  <span className="thing thing-1">a 100 page PDF<span className="grey">,</span></span>
                  <span className="thing thing-2">a large spreadsheet<span className="grey">,</span></span>
                  <span className="thing thing-3">a long email<span className="grey">,</span></span>
                </span> <br/>
                wishing you had a better way to find the relevant parts?
                &nbsp;<a href="#join-the-journey">Click here</a>
            </div>

            <div className="example">
              <h3>Enhanced reading:</h3>
              <div className="screenshot">                
                  <div className="inner">
                      <img src="./app.png" />
                  </div>
              </div>
            </div>


            <div className="example">
              <h3>Enriched spreadsheets:</h3>
              <div className="screenshot">                
                  <div className="inner">
                      <img src="./excel.png" />
                  </div>
              </div>
            </div>

            <div id="join-the-journey">
                <div className="inner">
                    <div className="header">
                      Get in touch
                    </div>

                  <p className="credits grey">
                    E-mail: <a href="mailto:hi@itsanno.com">hi@itsanno.com</a>
                  </p>

                  <View width={Math.min(window.innerWidth - 10, 500)} height={200} ></View>                  
            </div>
        </div>
      </div>      
    </div>
  );
}

export default App;
